// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"71edbf6d","632":"7b249631"}[chunkId] + ".chunk.js";
};